<template>
    <div class="page">
        <a-row :gutter="24">
            <a-col :xs="{span:24}" :sm="{span:8}">
                <div>
                    <ul class="ztree content">
                        <z-org-tree
                            ref="orgTree"
                            :option="orgOption"
                            @addNode="onAddNode"
                            @deleteNode="onDeleteNode"
                            @orgSelect="onSelectNode">
                        </z-org-tree>
                    </ul>
                </div>
            </a-col>

            <a-col :xs="{span:24}" :sm="{span:16}">
                <div class="content"  style="height: 80vh">
                    <z-org-detail v-if="!isAddOrg" ref="orgDetail" :entityTemplates="entityTemplates" @refreshTree="refreshTree"></z-org-detail>
                    <z-add-org v-if="isAddOrg" ref="addOrg" :entityTemplates="entityTemplates" @addSuccess="refreshTree"></z-add-org>
                </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import config from '@/config'
    import ZOrgTree from './OrgTree.vue'
    import ZOrgDetail from '@/views/org/OrgDetail.vue'
    import ZAddOrg from '@/views/org/AddOrg.vue'
    import {mapGetters} from 'vuex'

    export default {
        data(){
            return {
                orgOption:{
                    value: ""
                },
                entityTemplates: [],
                isAddOrg: false
            }
        },
        computed: {
            ...mapGetters([
                'isSuperAdmin','isIntegrator'
            ])
        },
        components:{
            ZOrgTree,
            ZOrgDetail,
            ZAddOrg
        },
        created () {
            if(this.isSuperAdmin || this.isIntegrator){
                this.$http.get(config.api.entity_template_url).then((response) => {
                    if(response.code == 0){
                        this.entityTemplates = response.result
                    }
                }).catch((err) => {
                    console.log(err)
                })
            }
        },
        methods: {
            onDeleteNode(node){
                this.$http.delete(config.api.org_url + '/' + node.id).then((response) => {
                    console.log(response)
                    if(response.code == 0){
                        this.$message.success('删除机构成功')
                        this.$refs["orgTree"].initOrgTree(null,node.pid)
                    } else {
                        this.$notification.error({
                            message: '删除失败',
                            description: response.desc
                        }) 
                    }
                })
            },
            onAddNode(node){
                this.isAddOrg = true
                this.$nextTick().then(() => {
                    this.$refs["addOrg"].showAddOrg(node)
                })
            },
            onSelectNode(node){
                this.isAddOrg = false
                this.$nextTick().then(() => {
                    this.$refs["orgDetail"].setOrg(this.clone(node))
                    this.$refs["orgDetail"].getSmsNum(node.id)
                })
            },
            refreshTree(nodeId){
                this.$refs["orgTree"].initOrgTree(null,nodeId)
            },
            clone(obj){
                if (null == obj || "object" != typeof obj) return obj;
                if (obj instanceof Date) {
                    let copy = new Date();
                    copy.setTime(obj.getTime());
                    return copy;
                }
                if (obj instanceof Array) {
                    let copy = [];
                    var len = obj.length;
                    for (var i = 0; i < len; ++i) {
                        copy[i] = this.clone(obj[i]);
                    }
                    return copy;
                }
                if (obj instanceof Object) {
                    let copy = {};
                    for (var attr in obj) {
                        if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
                    }
                    return copy;
                }
                throw new Error("Unable to copy obj! Its type isn't supported.");
            }
        }
    }
</script>


<style lang="less" scoped>
.ztree {
    max-height: 80vh !important;
    overflow-y: auto !important;
    height: 80vh;
}
</style>
